import _classCallCheck from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Util } from '../Util.js';
import { Factory } from '../Factory.js';
import { Shape } from '../Shape.js';
import { getNumberValidator } from '../Validators.js';
import { _registerNode } from '../Global.js';
export var Image =
/*#__PURE__*/
function (_Shape) {
  _inherits(Image, _Shape);

  function Image(attrs) {
    var _this;

    _classCallCheck(this, Image);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Image).call(this, attrs));

    _this.on('imageChange.konva', function () {
      _this._setImageLoad();
    });

    _this._setImageLoad();

    return _this;
  }

  _createClass(Image, [{
    key: "_setImageLoad",
    value: function _setImageLoad() {
      var _this2 = this;

      var image = this.image();

      if (image && image.complete) {
        return;
      }

      if (image && image.readyState === 4) {
        return;
      }

      if (image && image['addEventListener']) {
        image['addEventListener']('load', function () {
          _this2._requestDraw();
        });
      }
    }
  }, {
    key: "_useBufferCanvas",
    value: function _useBufferCanvas() {
      return _get(_getPrototypeOf(Image.prototype), "_useBufferCanvas", this).call(this, true);
    }
  }, {
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      var width = this.getWidth();
      var height = this.getHeight();
      var image = this.attrs.image;
      var params;

      if (image) {
        var cropWidth = this.attrs.cropWidth;
        var cropHeight = this.attrs.cropHeight;

        if (cropWidth && cropHeight) {
          params = [image, this.cropX(), this.cropY(), cropWidth, cropHeight, 0, 0, width, height];
        } else {
          params = [image, 0, 0, width, height];
        }
      }

      if (this.hasFill() || this.hasStroke()) {
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
      }

      if (image) {
        context.drawImage.apply(context, params);
      }
    }
  }, {
    key: "_hitFunc",
    value: function _hitFunc(context) {
      var width = this.width(),
          height = this.height();
      context.beginPath();
      context.rect(0, 0, width, height);
      context.closePath();
      context.fillStrokeShape(this);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      var _a, _b;

      return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      var _a, _b;

      return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
  }], [{
    key: "fromURL",
    value: function fromURL(url, callback) {
      var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var img = Util.createImageElement();

      img.onload = function () {
        var image = new Image({
          image: img
        });
        callback(image);
      };

      img.onerror = onError;
      img.crossOrigin = 'Anonymous';
      img.src = url;
    }
  }]);

  return Image;
}(Shape);
Image.prototype.className = 'Image';

_registerNode(Image);

Factory.addGetterSetter(Image, 'image');
Factory.addComponentsGetterSetter(Image, 'crop', ['x', 'y', 'width', 'height']);
Factory.addGetterSetter(Image, 'cropX', 0, getNumberValidator());
Factory.addGetterSetter(Image, 'cropY', 0, getNumberValidator());
Factory.addGetterSetter(Image, 'cropWidth', 0, getNumberValidator());
Factory.addGetterSetter(Image, 'cropHeight', 0, getNumberValidator());